var loadMoreButton = document.getElementById('when-to-see-load-more');
var camps = document.getElementsByClassName('when-to-see-card');
var x = 3;
var y = 4;
var z = 5;

if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function(event) {
        event.preventDefault();
        console.log('load more clicked');
        newCount(x,y,z);
    
        x = x + 3;
        y = y + 3;
        z = z + 3;
        
    })
}

function newCount(x,y,z) {

    for (var i = 0; i < camps.length; i++) {

        if (x + 1 > camps.length) {
            x = '';
        }
        if (y + 1 > camps.length) {
            y = '';
        }
        if (z + 1 > camps.length) {
            z = '';
        }
    }

    updateClasses(x, y, z);
}

function updateClasses(x, y, z) {
    if (x !== '') {
        camps[x].classList.remove('location-card--disabled');
    } 
    if (y !== '') {
        camps[y].classList.remove('location-card--disabled');
    } 
    if (z !== '') {
        camps[z].classList.remove('location-card--disabled');
    }

    if (x == '' || y == '' || z == '') {
        loadMoreButton.style.display = 'none';
    }
}